import Link, { Appearance } from '@cinch/oxd-components/link/src'
import { Text, TextStyles } from '@cinch-labs/design-system'
import React from 'react'
import * as styles from './manufacturer-intro.module.css'

interface ManufacturerOverviewProps {
  title: string
  body: React.ReactNode
  searchUrl: string
  vehiclesAvailable?: boolean
  i18n: Cinch.WebAppTranslations['manufacturer']
}

const Intro: React.FC<ManufacturerOverviewProps> = ({ title, body, searchUrl, vehiclesAvailable = true, i18n }) => {
  const ctaTitle = i18n.findMore.replace('{placeholder}', title)

  return (
    <div className={styles.intro}>
      <div>
        <Text oxford={true} className={styles.title} element={'h1'} type={TextStyles.vehicleTitle}>
          {i18n.introduction.replace('{placeholder}', title)}
        </Text>
        <div className={styles.bodyText}>{body}</div>
        <Link
          oxford={true}
          isDisabled={!vehiclesAvailable}
          data-testid="more-cars"
          appearance={Appearance.primaryButton}
          to={searchUrl}
          tag={{
            event: 'click',
            eventCategory: 'button',
            eventLabel: ctaTitle,
            eventAction: 'navigation',
          }}
        >
          {ctaTitle}
        </Link>
      </div>
    </div>
  )
}

export default Intro
